export function polishYearsLabel(value) {
  const count = Math.abs(Math.trunc(Number(value)));

  if (count === 1) return "rok";

  const lastTwoDigits = count % 100;
  const lastDigit = count % 10;
  if (lastTwoDigits < 12 || lastTwoDigits > 14) {
    if (lastDigit >= 2 && lastDigit <= 4) return "lata";
  }

  return "lat";
}
